import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPowerPlant: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPowerPlant"><Path d="M5.5 7.5H10.25L12.25 20.5H3.5L5.5 7.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 3.5H10C8.89543 3.5 8 4.39543 8 5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.4648 13.25L15.0363 11.5V14L20.5363 11.5V20.5H12.0363" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPowerPlant;
